import request from '@/utils/request'
import {uuid} from 'vue-uuid'

export function getProjectByCompany(company_uid){
  return request({
    url: "/api/projects/company/" + company_uid,
    method: "get"
  });
}

export function getProjectBy(uid){
  return request({
    url: "/api/projects/" + uid,
    method: "get"
  });
}

export function projectActive(uid){
  return request({
    url: "/api/projects/" + uid,
    method: "post",
    data:{idempotency: uuid.v1()}
  });
}

export function createProject(company_uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/projects/company/" + company_uid,
    method: "post",
    data: data
  });
}
export function updateProject(uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/projects/" + uid,
    method: "put",
    data: data
  });
}

export function delProject(uid){
  return request({
    url: "/api/projects/" + uid,
    method: "delete",
    data: {idempotency: uuid.v1()}
  });
}

export function getDistributionCode(){
  return request({
    url: "/api/projects/distributorcode",
    method: "get"
  });
}

export function getWebhook(uid){
  return request({
    url: `/api/projects/${uid}/webhook`,
    method: "get"
  });
}

export function updateWebhook(uid, data){
  return request({
    url: `/api/projects/${uid}/webhook`,
    method: "put",
    data: data
  });
}
export function testWebhook(uid, data){
  return request({
    url: `/api/projects/${uid}/webhook/sendtest`,
    method: "post",
    data: data
  });
}

export function getLogo(uid){
  return request({
    url: `/api/projects/${uid}/logo`,
    method: "get",
    responseType:"arraybuffer"
  });
}

export function removeLogo(uid){
  return request({
    url: `/api/projects/${uid}/logo`,
    method: "delete"
  });
}